// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"authLoader-module__loaderWrapper__XXJa4","loader":"authLoader-module__loader__03QnN","loadingspin":"authLoader-module__loadingspin__MomAe"};